// import product from "../../components/product/product.vue";
// import designer from "../../components/product/designer/index.vue";

export default[
	{
		path: "/product",
		component: () => import("../../components/main.vue"),
		meta: {
			title: '产品介绍'
		},
		children:[
			{
				path:'studio',
				component: () => import("../../components/product/studio/index.vue"),
				meta: {
					title: '机器人设计器'
				}
			},{
				path:'airpa',
				component: () => import("../../components/product/airpa/index.vue"),
				meta: {
					title: 'AIRPA'
				}
			},{
				path:'butler',
				component: () => import("../../components/product/butler/index.vue"),
				meta: {
					title: '机器人管家'
				}
			},{
				path:'actuator',
				component: () => import("../../components/product/actuator/index.vue"),
				meta: {
					title: '机器人执行引擎'
				}
			}
		]
	}
]
